module.exports = {"340504001":"平湖街道","340504002":"雨山街道","340504003":"安民街道","340504004":"采石街道","340504100":"向山镇","340504101":"银塘镇","340504200":"佳山乡","340504401":"雨山经济开发区","340504402":"市经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340504.json
// module id = 1074
// module chunks = 0